import useMutation from "src/hooks/useMutation";

function useWarehouseUpdate(id) {
  return useMutation({
    path: `/api/v1/warehouses/${id}`,
    method: "PUT",
    mutateRelatedDataList: {
      mutatePath: `/api/v1/warehouses`,
      shouldRevalidate: true,
    },
  });
}

export default useWarehouseUpdate;
